var map = {
	"./danielaRizzi@2x.jpg": "859b",
	"./dariaPushkova@2x.jpg": "ed2f",
	"./flaminiaGiorda@2x.jpg": "111c",
	"./marinaLoshak@2x.jpg": "b517",
	"./teresaIarocciMavica@2x.jpg": "e576"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f0b";